import React from 'react';
import {IProps} from './interface';
import Loadable from 'react-loadable';
import LoadableLoading from '../../components/LoadableLoading';
import {getAvailableColumns, getAvailableGroupColumns} from './api';

export const path = '/event/list';

const getPage = () => import('./page');

const PageEvents: React.FC<IProps> = (props) => {
    const loader = {
        page: () => getPage(),
        i18n: () => import(`./ru.json`),
        columns: getAvailableColumns,
        groupColumns: getAvailableGroupColumns
    };

    const LoadableMap = Loadable.Map({
        loader,
        loading: LoadableLoading,
        render(loaded, loadedProps) {
            const Page = loaded.page.default;

            return (
                <Page
                    {...loadedProps}
                    {...props}
                    i18n={loaded.i18n}
                    columns={loaded.columns}
                    groupColumns={loaded.groupColumns[0].columns}
                />
            )
        }
    })

    return <LoadableMap {...props} />;
};

export default PageEvents;